import { render, staticRenderFns } from "./drocessRecord.vue?vue&type=template&id=beac96aa&scoped=true"
import script from "./drocessRecord.vue?vue&type=script&lang=js"
export * from "./drocessRecord.vue?vue&type=script&lang=js"
import style0 from "./drocessRecord.vue?vue&type=style&index=0&id=beac96aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac96aa",
  null
  
)

export default component.exports